import React, { useState } from 'react'
import { IoIosSearch } from "react-icons/io";

const SearchField = ({search,setSearch}) => {
   

    return (
        <div
            className="flex flex-col w-full relative sm:max-w-80 "
        >
            <input
                type="text"
                value={search}
                onChange={(e)=>setSearch(e.target.value)}
                placeholder="Search"
                className="w-full h-[40px] rounded-[7px] px-[42px] text-[14px]
                 text-[#131415] font-[500] w-full focus:outline-none focus:ring-[1px]
                  focus:ring-[#EF5A24] focus:border-[#EF5A24] hover:border-[1px] hover:border-[#EF5A24]
               border-[1px] border-[#CACACA] transition-all"

            />
            <span className="absolute top-[10px] left-3">
                <IoIosSearch size={22} className="text-[#0C0C0C66]/60" />
            </span>


        </div>
    )
}

export default SearchField;